import { IRecentProfessional, IRecentProfessionalApi } from './recentProfessionalsTypes';

function toRecentProfessional(businessApi: IRecentProfessionalApi): IRecentProfessional {
  return {
    id: businessApi.id,
    jobDatetime: businessApi.job_datetime,
    profession: businessApi.profession,
    professional: {
      fullName: businessApi.professional.full_name,
      id: businessApi.professional.id,
      image: businessApi.professional.image,
      overallProfessionalRating: businessApi.professional.overallProfessionalRating,
      professions: businessApi.professional.professions,
    },
    professionalRating: businessApi.professionalRating,
    ratingCount: businessApi.ratingCount,
  };
}

export const recentProfessionalsAdapter = { toRecentProfessional };
